var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"account-pages mt-5 mb-5"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)]),_c('footer',{staticClass:"footer footer-alt"},[_vm._v("\n    WellKey - PT. RIGSIS Energi Indonesia © "+_vm._s(_vm.year)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }